import type {IModalOverlayVariant} from "@pg-design/modal-module";
import {UserPhoneVerification as UserPhoneVerificationBase} from "@pg-mono/user";

import {UserPhoneVerificationProvider} from "../../providers/UserPhoneVerificationProvider";
import {trackAmplitudePhoneVerified} from "../../tracking/track_amplitude_phone_verified";

interface IProps {
    isOpen: boolean;
    onClose: () => void;
    onSuccess: () => void;
    onChangeNumber: () => void;
    overlayVariant?: IModalOverlayVariant;
}

export const HomeMatchBasicPreferencesFlowPhoneVerificationModal = (props: IProps) => {
    const {isOpen, onClose, onSuccess, onChangeNumber, overlayVariant} = props;

    const handleClose = () => {
        trackAmplitudePhoneVerified(false);
        onClose();
    };

    return (
        <UserPhoneVerificationProvider>
            <UserPhoneVerificationBase
                isOpen={isOpen}
                onClose={handleClose}
                onSuccess={onSuccess}
                onChangeNumber={onChangeNumber}
                overlayVariant={overlayVariant}
            />
        </UserPhoneVerificationProvider>
    );
};
import type {IModalOverlayVariant} from "@pg-design/modal-module";
import {UserPhoneVerification as UserPhoneVerificationBase} from "@pg-mono/user";

import {UserPhoneVerificationProvider} from "../../providers/UserPhoneVerificationProvider";
import {trackAmplitudePhoneVerified} from "../../tracking/track_amplitude_phone_verified";

interface IProps {
    isOpen: boolean;
    onClose: () => void;
    onSuccess: () => void;
    onChangeNumber: () => void;
    overlayVariant?: IModalOverlayVariant;
}

export const HomeMatchBasicPreferencesFlowPhoneVerificationModal = (props: IProps) => {
    const {isOpen, onClose, onSuccess, onChangeNumber, overlayVariant} = props;

    const handleClose = () => {
        trackAmplitudePhoneVerified(false);
        onClose();
    };

    return (
        <UserPhoneVerificationProvider>
            <UserPhoneVerificationBase
                isOpen={isOpen}
                onClose={handleClose}
                onSuccess={onSuccess}
                onChangeNumber={onChangeNumber}
                overlayVariant={overlayVariant}
            />
        </UserPhoneVerificationProvider>
    );
};
